import { graphql } from 'gql.tada';
import { client } from '../client';

export const selectDeliveryOptionMutation = graphql(`
  mutation SelectDeliveryOption($input: SelectDeliveryOptionInput!) {
    selectDeliveryOption(input: $input) {
      id
      customerId
      items {
        resolution
        reason {
          title
          id
          fields {
            value
            type
          }
          children {
            title
            id
            fields {
              value
              type
            }
          }
          resolutions {
            id
            scope
          }
        }
        quantity
        item {
          variantId
          sku
          id
        }
        id
        exchange {
          variantInfo {
            value
            name
          }
          variantId
          sku
          productId
          price {
            value
            formattedString
            currency
          }
          name
          image
          id
        }
        delivery {
          type
          serviceProviderId
          serviceType
          packagingOption
          locationProviderId
        }
        comment
      }
      refund {
        type
      }
      delivery {
        type
        serviceProviderId
        serviceType
        packagingOption
        locationProviderId
      }
      attributes {
        value
        name
      }
      address {
        provinceCode
        province
        postalCode
        lastName
        firstName
        countryCode
        city
        address2
        address1
      }
      validationErrors {
        code
      }
    }
  }
`);

export const selectDeliveryOptionMutationFn = (
  input: SelectDeliveryOptionVariables['input'],
) =>
  client.request(selectDeliveryOptionMutation, {
    input,
  });

/* eslint-disable typescript/no-explicit-any -- Required for gql.tada type inference */
export type SelectDeliveryOptionVariables =
  typeof selectDeliveryOptionMutation extends import('gql.tada').TadaDocumentNode<
    any,
    infer T,
    any
  >
    ? T
    : never;
/* eslint-enable typescript/no-explicit-any */

export type SelectDeliveryOptionResult = Awaited<
  ReturnType<typeof selectDeliveryOptionMutationFn>
>;
